import { render } from "./TanaoroshiPage.vue?vue&type=template&id=321d9635&scoped=true"
import script from "./TanaoroshiPage.vue?vue&type=script&lang=js"
export * from "./TanaoroshiPage.vue?vue&type=script&lang=js"

import "./TanaoroshiPage.vue?vue&type=style&index=0&id=321d9635&lang=scss&scoped=true"

import exportComponent from "C:\\tmp\\hybrid-web-api\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321d9635"]])

export default __exports__